import { FC } from 'react';
import styled from 'styled-components';
import colors from '../../styles/colors';

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: 2rem;
`;

const Button = styled.button`
  padding: 6px 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.07);
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.4);
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &.active {
    background: ${colors.bgColorBordeaux};
    border-color: ${colors.bgColorBordeaux};
    color: white;
    font-weight: 700;
  }
`;

interface PaginationProps {
  currentPage: number;
  lastPage: number;
  onPageChange: (page: number) => void;
  className?: string;
}

const Pagination: FC<PaginationProps> = ({ currentPage, lastPage, onPageChange, className = '' }) => {
  return (
    <PaginationContainer className={className}>
      <Button
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
      >
        «
      </Button>
      <Button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        ‹
      </Button>

      {Array.from({ length: Math.min(5, lastPage) }, (_, i) => {
        const pageNum = Math.max(1, currentPage - 2) + i;
        if (pageNum <= lastPage) {
          return (
            <Button
              key={pageNum}
              onClick={() => onPageChange(pageNum)}
              className={pageNum === currentPage ? 'active' : ''}
            >
              {pageNum}
            </Button>
          );
        }
        return null;
      })}

      <Button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === lastPage}
      >
        ›
      </Button>
      <Button
        onClick={() => onPageChange(lastPage)}
        disabled={currentPage === lastPage}
      >
        »
      </Button>
    </PaginationContainer>
  );
};

export default Pagination;
